<template>
  <div>
    <el-upload
      v-if="small"
      class="upload-demo"
      :action="`${action}${url}`"
      :on-success="uploadSuccess"
      :on-error="onError"
      multiple
      :show-file-list="false">
      <el-button size="small" type="primary">{{btnName}}</el-button>
    </el-upload>
    <el-upload
      v-else
      drag
      :action="`${action}${url}`"
      :on-success="uploadSuccess"
      :on-error="onError"
      multiple
      :show-file-list="false">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div v-if="remark" class="el-upload__tip" slot="tip"></div>
    </el-upload>
  </div>
  
</template>
<script>
export default {
  props: {
    btnName: {
      type:String,
      default: '点击上传'
    },
    url: {
      type: String,
      default: '/stu/oss/upload'
    },
    small: {
      type: Boolean,
      default: false
    },
    remark: {
      type: String,
      default: '只能上传jpg/png文件，且不超过500kb'
    }
  },
  data() {
    return {}
  },
  computed: {
    action() {
      if(process.env.NODE_ENV === 'production') {
        return 'https://api.ccqf.vip'
      }else {
        return '/api'
      }
    },
    headers() {
      return {
        'X-Authorization': window.$cookie.get('token')
      }
    }
  },
  methods: {
    onError(err) {
      console.log(err)
    },
    uploadSuccess(res,file) {
      if(res.code === 200) {
        this.$message.success(res.message)
        this.$emit('success', res.result)
      } else {
        this.$message.error(res.message)
      }

    
    },
  }
}
</script>
<style lang="less" >
#app .upload-small {
  .el-upload {
    .el-upload-dragger {
      width: 200px;
      height: 100px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/components/Util/Upload.vue